import ModalWrapper from "@app/common/ModalWrapper";
import { Modal } from "@app/const/consts";
import {
  Button,
  FormLabel,
  ILibModalSizes,
  Input,
} from "@infologistics/frontend-libraries";
import React, {
  ChangeEvent,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { IProps } from "./types";
import { useTranslation } from "react-i18next";
import { resetModal } from "@app/store/modules/modal";
import cn from "classnames";
import {
  getDeclineContentTranslation,
  getDeclineTranslation,
  handleDeclineTask,
} from "@app/utils/envelope";
import { useAppDispatch } from "@app/hooks";
import { Nullable } from "@app/store/types";
import { useMediaQuery } from "react-responsive";

const INPUT_COMMENT = "input_comment";

export const EnvelopeDeclineModal = (props: IProps): ReactElement => {
  const { onCloseModal } = props;

  const [comment, setComment] = useState<Nullable<string>>(null);
  const [modalSize, setModalSize] = useState<ILibModalSizes>(
    ILibModalSizes.SMALL,
  );

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 400px)" });

  const { t } = useTranslation(["common", "envelopes"]);

  const dispatch = useAppDispatch();

  const title = getDeclineTranslation();
  const content = getDeclineContentTranslation() + "?";

  useEffect(() => {
    setModalSize(ILibModalSizes.SMALL);

    if (isTabletOrMobile) {
      setModalSize(ILibModalSizes.SEMI_SMALL);
    }

    if (isMobile) {
      setModalSize(ILibModalSizes.EXTRA_SMALL);
    }
  }, [isTabletOrMobile, isMobile]);

  const handleCommentChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setComment(e.target.value);
  };

  const handleSubmit = () => {
    handleDeclineTask(comment, handleCloseClick(true))();
  };

  const handleClose = (reload?: boolean) => {
    setComment(null);
    onCloseModal?.(reload);
  };

  const handleCloseClick = (reload?: boolean) => () => {
    dispatch(resetModal());
    handleClose(reload);
  };

  const renderHeader = (): ReactNode => {
    return (
      <header
        className="modal-header fl-notification-confirm_title d-flex justify-content-between align-items-start p-4 fw-300 bg-danger-100"
        id="myModalLabel"
      >
        <h4 className="m-0">{title}</h4>
      </header>
    );
  };

  const renderBody = (): ReactNode => {
    return (
      <div className={cn("modal-body")}>
        <div className="fl-notification-confirm_message pb-2 mb-4 font-md">
          {content}
        </div>
        <div>
          <FormLabel htmlFor={INPUT_COMMENT} className="font-default">
            {t("common:comment")}
          </FormLabel>
          <Input
            name={INPUT_COMMENT}
            value={comment}
            onChange={handleCommentChange}
          />
        </div>
      </div>
    );
  };

  const renderFooter = (): ReactNode => {
    return (
      <footer className="modal-footer d-flex justify-content-end">
        <Button type="submit" onClick={handleSubmit} theme="primary">
          {t("common:yes")}
        </Button>
        <Button onClick={handleCloseClick(false)} externalClass="ml-4">
          {t("common:no")}
        </Button>
      </footer>
    );
  };

  return (
    <ModalWrapper
      id={Modal.DECLINE}
      size={modalSize}
      onCloseModal={handleClose}
      backdrop={false}
    >
      {renderHeader()}
      {renderBody()}
      {renderFooter()}
    </ModalWrapper>
  );
};
